import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { openAddReclamationDialog } from 'store/common/commonActions';

import InformationsPage from './InformationsPage';

import { fetchInfosLogistique } from 'store/information/logistiqueActions';
import { clearPiecesGestion } from 'store/pieceGestion/pieceGestionActions';
import { clearSearchPieceFilters } from 'store/pieceGestion/pieceGestionActions';

const Namespace = 'informationLogistique';

class InformationsPageContainer extends React.Component {
    constructor(props) {
        super(props);

        const { clearSearchPieceFilters } = this.props;

        clearSearchPieceFilters();
    }

    async componentDidMount() {
        const { params, fetchInfosLogistique } = this.props;
        
        // Si un numeroPiece est présent dans l'URL, on charge les infos de cette pièce
        if (params && params.numeroPiece) {
            await fetchInfosLogistique(params.numeroPiece);
        }
    }

    handleChangeClient = () => {
        const { clearPiecesGestion } = this.props;

        clearPiecesGestion();
    }

    handleSelectPiece = (numeroPiece) => {
        const { fetchInfosLogistique } = this.props;

        fetchInfosLogistique(numeroPiece);
    }


    handleClickCreate = (infosLogistique) => {
        const { openAddReclamationDialog  } = this.props;

        openAddReclamationDialog(false, -1, infosLogistique);
    }

    render() {
        const { params } = this.props;
        const initialNumeroPiece = params && params.numeroPiece ? params.numeroPiece : '';
        
        return (
            <InformationsPage
                onSelectPiece={this.handleSelectPiece}
                onChangeClient={this.handleChangeClient}
                namespace={Namespace}
                onClickCreate={this.handleClickCreate}
                initialNumeroPiece={initialNumeroPiece}
            />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    fetchInfosLogistique: x => dispatch(fetchInfosLogistique(x)),
    clearPiecesGestion: () => dispatch(clearPiecesGestion(Namespace)),
    clearSearchPieceFilters: () => dispatch(clearSearchPieceFilters(Namespace)),

    openAddReclamationDialog: (reclamationLiee, reclamationParentId, infosLogistique) => dispatch(openAddReclamationDialog(reclamationLiee, reclamationParentId, infosLogistique))
    
});

// HOC pour extraire le paramètre numeroPiece de l'URL
function withRouter(Component) {
    const WithRouter = props => {
        const params = useParams();
        return <Component {...props} params={params} />;
    };
    WithRouter.displayName = `WithRouter(${Component.displayName || Component.name || 'Component'})`;
    return WithRouter;
}

// Connecter le composant à Redux et au router
export default withRouter(connect(null, mapDispatchToProps)(InformationsPageContainer));